module.exports = __webpack_public_path__ + "media/images/ninestars/clients/client-2-db464439fcf5de975c2664f7af275a45.png";